import { useEffect, useState } from 'react';

export const usePreviewUrl = (preview?: Blob | string) => {
  const [objectUrl, setObjectUrl] = useState<string>();

  useEffect(() => {
    if (!(preview instanceof Blob) || !preview.type.startsWith('image/')) {
      setObjectUrl(undefined);
      return;
    }

    const url = URL.createObjectURL(preview);
    setObjectUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [preview]);

  return typeof preview === 'string' ? preview : objectUrl;
};
